import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageCircle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useOpenSupportChat } from '../../hooks/usePublicSupportContacts';

/** Global floating support FAB — in Telegram opens Support Bot; on web opens in-app chat. */
export function SupportChatFab() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { unreadSupportChat, isAuthenticated } = useAuth();
  const { openSupport, isTelegramMode } = useOpenSupportChat();

  useEffect(() => {
    if (!isTelegramMode) {
      void import('../../pages/SupportChatPage');
    }
  }, [isTelegramMode]);

  return (
    <div className="cs-support-fab-root">
      <button
        type="button"
        className="cs-support-fab"
        aria-label={t('home.chatWithUs')}
        onClick={() => {
          const mode = openSupport();
          if (mode === 'telegram') return;
          if (!isAuthenticated) {
            navigate('/login?returnTo=%2Fsupport%2Fchat');
            return;
          }
          navigate('/support/chat', { state: { softEnter: true } });
        }}
      >
        <span className="cs-support-fab__icon cs-support-fab__icon--chat" aria-hidden>
          <MessageCircle size={24} strokeWidth={2.1} />
        </span>
        {!isTelegramMode && unreadSupportChat > 0 ? (
          <span className="cs-support-fab__badge">
            {unreadSupportChat > 99 ? '99+' : unreadSupportChat}
          </span>
        ) : null}
      </button>
    </div>
  );
}
